import request from '@/utils/request'

export function getActiveSchools(isInternalTransfer) {
    return request({
        url: 'transfer/activeschools',
        method: 'post',
        data: { isInternalTransfer: isInternalTransfer }
    })
}

export function transferToQomRequest(schools) {
    return request({
        url: 'transfer/qomupload',
        method: 'post',
        data: { schools: schools }
    })
}

export function transferToOstanRequest(file, schoolID, comment) {
    let fileName = file == null ? "" : file.name
    var fmData = new FormData();

    fmData.append('schoolID', schoolID.toString())
    fmData.append('comment', comment)
    fmData.append('image', file)
    fmData.append('fileName', fileName)

    return request({
        url: 'transfer/inostanupload',
        method: 'post',
        data: fmData

    })
}

export function getTransfersHistory() {
    return request({
        url: 'transfer/gethistory',
        method: 'post'
    })
}

export function removeTransferRequest(requestID) {
    return request({
      url: 'transfer/remove',
      method: 'post',
      data: { requestID: requestID }
    })
  }